module.exports = __webpack_public_path__ + "_/node_modules/@catalytic/pushbot-ui-xtras/assets/fonts/NotoSansUI-Regular.eot?aa2229b6f9a5b0a0c8e2752a2a6ce697]";


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui-xtras/assets/fonts/NotoSansUI-Regular.eot
// module id = 1887
// module chunks = 32